import React, {useState, useEffect, useRef, useContext} from 'react';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import DrawRoundedIcon from '@mui/icons-material/DrawRounded';

import {Dialog, Transition} from '@headlessui/react';
import {ExclamationTriangleIcon} from '@heroicons/react/24/outline';

import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import ExitForm from '../../ExitFormModal';
import KeyboardBackspaceRoundedIcon from '@mui/icons-material/KeyboardBackspaceRounded';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import CreateIcon from '@mui/icons-material/Create';
import SelectComponent from '../../Selects/SelectComponent';
import Datepicker from 'react-tailwindcss-datepicker';
import MultiSelect from '../../Selects/MultiSelect';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import TaskRoundedIcon from '@mui/icons-material/TaskRounded';
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded';
import VerifiedUserRoundedIcon from '@mui/icons-material/VerifiedUserRounded';
import DownloadDoneRoundedIcon from '@mui/icons-material/DownloadDoneRounded';
import FileCopyRoundedIcon from '@mui/icons-material/FileCopyRounded';
import AssinaturaModal from './AssinaturaModal';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {ToastContainer} from 'react-toastify';
import {aprovarOrcamento, assinarOrcamento, encomendarOrcamento} from '../../../pages/requests';
import EncomendaModal from './EncomendaModal';
import AprovacaoModal from './AprovacaoModal';
import {Context} from '../../../Helpers/Auth';
import LocalPrintshopRoundedIcon from '@mui/icons-material/LocalPrintshopRounded';

function DrawerFilter({
    setGuardar,
    setEnviarEmailProposta,
    setGerarRevisaoProposta,

    showForm,
    setShowForm,
    onChangeForm,
    setOnChangeForm,
    editarProposta,
    setEditarProposta,

    setOpenTab,
    setPropostaSelecionada,
    propostaSelecionada,
    filtroTipo,
    setFiltroTipo,
    filtroDt,
    setFiltroDt,
    filtroCliente,
    setFiltroCliente,
    filtroEstado,
    setFiltroEstado,
    filtroRepresentantes,
    setFiltroRepresentantes,
    filtroLinhas,
    setFiltroLinhas,
    tipos,
    estados,
    encomendas,
    representantes,
    proposta,
    openTab,
    // filtro status
    filtroDtStatus,
    setFiltroDtStatus,
    filtroUtilizador,
    setFiltroUtilizador,
    filtroAcao,
    setFiltroAcao,
    filtroDestinatarios,
    setFiltroDestinatarios,
    filtroEmail,
    setFiltroEmail,
    imprimirProposta,
    setImprimirProposta,
    filtroDescNegocio,
    setFiltroDesNegocio,
    filtroEncomenda,
    setFiltroEncomenda,
}) {
    const {t} = useTranslation();
    const {userRepresentante, isCard, setIsCard, openCards, setOpenCards, acessos} = useContext(Context);

    const history = useHistory();
    const [open, setOpen] = useState(false);
    const cancelButtonRef = useRef(null);
    const [openExit, setOpenExit] = useState(false);
    const [openModalAssinatura, setOpenModalAssinatura] = useState(false);
    const [openModalEncomenda, setOpenModalEncomenda] = useState(false);
    const [openModalAprovacao, setOpenModalAprovacao] = useState(false);
    const FORMATO_DATA = 'YYYY-MM-DD';
    const [isMobile, setIsMobile] = useState(false);

    const [state, setState] = useState({
        right: false,
    });

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }
    console.log(propostaSelecionada, 'proposta');
    const permissao = acessos.find(element => element.funcao == 'GESOPP') ?? {
        apagar: false,
        consultar: false,
        criar: false,
        funcao: 'GESOPP',
        modificar: false,
    };

    const handleResize = () => {
        setIsMobile(window.innerWidth < 900);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleDrawer = (anchor, open) => event => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({...state, [anchor]: open});
    };

    const closeDrawer = anchor => {
        setState({...state, [anchor]: false});
    };

    function showButton(params) {
        if (filtroCliente != '' || filtroDt.startDate != null || filtroEstado != null || filtroLinhas != '' || filtroTipo != null) {
            return true;
        } else {
            return false;
        }
    }

    function limparFiltros() {
        setFiltroTipo(null);
        setFiltroDt({startDate: null, endDate: null});
        setFiltroCliente('');
        setFiltroEstado(null);
        setFiltroRepresentantes([]);
        setFiltroLinhas('');
    }

    const list = anchor => (
        <ClickAwayListener onClickAway={() => closeDrawer(anchor)}>
            <Box sx={{width: 320}} role="presentation" className="h-full  bg-white w-80 dark:bg-gray-800">
                <h5 id="drawer-label" className="inline-flex p-4 items-center mb-6 text-base font-semibold text-blue-600 uppercase dark:text-blue-600">
                    <FilterAltIcon className="mr-2" />
                    {t('filtros')}
                </h5>
                <button
                    type="button"
                    data-drawer-hide="drawer-contact"
                    aria-controls="drawer-contact"
                    onClick={() => closeDrawer(anchor)}
                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-blue-600 rounded-[8px] text-sm w-8 h-8 absolute top-2.5 right-2.5 inline-flex items-center justify-center dark:hover:bg-blue-600 dark:hover:text-white">
                    <CloseIcon />
                    <span className="sr-only">Close menu</span>
                </button>
                <div className="mb-6 p-4">
                    {!showForm && (
                        <>
                            <div className="relative mt-4">
                                <label htmlFor="first_name" className=" mb-2 block text-sm font-medium text-gray-900 dark:text-white">
                                    {t('cliente')}
                                </label>
                                <input
                                    type="search"
                                    id="default-search"
                                    value={filtroCliente}
                                    className="block w-full p-2 pl-2 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder={t('filtro')}
                                    onChange={e => {
                                        setFiltroCliente(e.target.value);
                                    }}
                                />
                            </div>
                            <div className="relative mt-4">
                                <label htmlFor="first_name" className=" mb-2 block text-sm font-medium text-gray-900 dark:text-white">
                                    {t('negocio')}
                                </label>

                                <input
                                    type="search"
                                    id="default-search"
                                    value={filtroDescNegocio}
                                    className="block w-full p-2 pl-2 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder={t('filtro')}
                                    onChange={e => {
                                        setFiltroDesNegocio(e.target.value);
                                    }}
                                />
                            </div>

                            <div className=" mt-4">
                                <label htmlFor="first_name" className="block text-sm font-medium text-gray-900 dark:text-white">
                                    {t('data')}
                                </label>
                                <Datepicker
                                    displayFormat={FORMATO_DATA}
                                    useRange={false}
                                    asSingle={false}
                                    value={filtroDt}
                                    onChange={newValue => {
                                        setFiltroDt(newValue);
                                    }}
                                    inputClassName={`rounded-[8px] w-full mt-2 bg-gray-50 border border-gray-300 text-lg text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                                />
                            </div>
                            <div className=" mt-4">
                                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    {t('tipo')}
                                </label>
                                <SelectComponent
                                    options={tipos}
                                    value={filtroTipo ? filtroTipo.label : ''}
                                    onChange={e => {
                                        setFiltroTipo(e.label);
                                    }}
                                    noOptionsMessage={t('semopcoes')}
                                    placeholder={t('filtroFamilia')}
                                />
                            </div>
                            <div className=" mt-4">
                                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    {t('estado')}
                                </label>
                                <SelectComponent
                                    options={estados}
                                    value={filtroEstado ? filtroEstado : ''}
                                    onChange={e => {
                                        setFiltroEstado(e);
                                    }}
                                    noOptionsMessage={t('semopcoes')}
                                    placeholder={t('filtroEstado')}
                                />
                            </div>
                            <div className=" mt-4">
                                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    {t('representante')}
                                </label>
                                <MultiSelect
                                    options={representantes}
                                    value={filtroRepresentantes}
                                    onChange={e => {
                                        setFiltroRepresentantes(e);
                                    }}
                                    noOptionsMessage={t('semopcoes')}
                                    placeholder={t('filtroGestor')}
                                />
                            </div>
                            <div className=" mt-4">
                                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    {t('convEncomenda')}
                                </label>
                                <SelectComponent
                                    options={encomendas}
                                    value={filtroEncomenda}
                                    onChange={e => {
                                        setFiltroEncomenda(e);
                                    }}
                                    noOptionsMessage={t('semopcoes')}
                                    placeholder={t('convEncomendaFiltro')}
                                />
                            </div>
                            {showButton() && (
                                <div className="flex flex-row justify-end mt-4">
                                    <button
                                        type="button"
                                        onClick={() => limparFiltros()}
                                        className="flex items-center font-semibold text-sm justify-center text-white bg-red-700 rounded-[8px] py-1 px-2 hover:bg-red-800 dark:bg-red-600 dark:hover:bg-red-700 focus:ring-4 focus:ring-red-300 focus:outline-none dark:focus:ring-red-800">
                                        {t('limparFiltros')} <CloseRoundedIcon />
                                    </button>
                                </div>
                            )}
                        </>
                    )}

                    {showForm && openTab == 7 && (
                        <>
                            <div className=" mt-4">
                                <label htmlFor="first_name" className="block text-sm font-medium text-gray-900 dark:text-white">
                                    {t('data')}
                                </label>
                                <Datepicker
                                    displayFormat={FORMATO_DATA}
                                    useRange={false}
                                    asSingle={true}
                                    value={filtroDtStatus}
                                    onChange={newValue => {
                                        setFiltroDtStatus(newValue);
                                    }}
                                    inputClassName={`rounded-[8px] w-full mt-2 bg-gray-50 border border-gray-300 text-lg text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                                />
                            </div>
                            <div className=" mt-4">
                                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    {t('utilizador')}
                                </label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                        <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                                        </svg>
                                    </div>
                                    <input
                                        type="search"
                                        id="default-search"
                                        value={filtroUtilizador}
                                        className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                        placeholder={t('filtro')}
                                        onChange={e => {
                                            setFiltroUtilizador(e.target.value);
                                        }}
                                    />
                                </div>
                            </div>
                            <div className=" mt-4">
                                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    {t('acao')}
                                </label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                        <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                                        </svg>
                                    </div>
                                    <input
                                        type="search"
                                        id="default-search"
                                        value={filtroAcao}
                                        className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                        placeholder={t('filtro')}
                                        onChange={e => {
                                            setFiltroAcao(e.target.value);
                                        }}
                                    />
                                </div>
                            </div>
                            <div className=" mt-4">
                                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    {t('destinatarios')}
                                </label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                        <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                                        </svg>
                                    </div>
                                    <input
                                        type="search"
                                        id="default-search"
                                        value={filtroDestinatarios}
                                        className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                        placeholder={t('filtro')}
                                        onChange={e => {
                                            setFiltroDestinatarios(e.target.value);
                                        }}
                                    />
                                </div>
                            </div>
                            <div className=" mt-4">
                                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    {t('email')}
                                </label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                        <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                                        </svg>
                                    </div>
                                    <input
                                        type="search"
                                        id="default-search"
                                        value={filtroEmail}
                                        className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                        placeholder={t('filtro')}
                                        onChange={e => {
                                            setFiltroEmail(e.target.value);
                                        }}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </Box>
        </ClickAwayListener>
    );

    function voltar() {
        setShowForm(false);
        setEditarProposta(false);
        setOnChangeForm(false);
        setOpenTab(1);
        setPropostaSelecionada(null);
    }

    function AssinarDoc() {
        assinarOrcamento(proposta.id, lang).then(res => {
            if (res.data.success) {
                toast.success(t('orcamentoAssinado'), {
                    position: 'top-right',
                    autoClose: 6000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: 'light',
                });
                voltar();
            } else {
                res.data.errorMessages.map(m =>
                    toast.error(m, {
                        position: 'top-right',
                        autoClose: 5000,
                    }),
                );
            }
        });
    }

    function Encomendar() {
        encomendarOrcamento(proposta.id, lang).then(res => {
            if (res.data.success) {
                //res.data.sohnum;
                toast.success(t('orcamentoAssinado'), {
                    position: 'top-right',
                    autoClose: 6000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: 'light',
                });
                voltar();
            } else {
                res.data.errorMessages.map(m =>
                    toast.error(m, {
                        position: 'top-right',
                        autoClose: 5000,
                    }),
                );
            }
        });
    }

    function AprovarOrcamento(aprovado, justificacao) {
        return aprovarOrcamento(proposta.id, aprovado, justificacao, lang).then(res => {
            voltar();
        });
    }

    return (
        <>
            <ToastContainer />
            <div className="flex flex-row items-center">
                {(!showForm || openTab == 7) && (
                    <>
                        {!isMobile && (
                            <>
                                <div className="flex items-center mr-3">
                                    <label className="relative inline-flex items-center cursor-pointer">
                                        <input type="checkbox" checked={isCard} onChange={() => setIsCard(!isCard)} className="sr-only peer" />
                                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-800 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                        <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{t('modoCard')}</span>
                                    </label>
                                </div>
                            </>
                        )}
                        {isCard && (
                            <div className="flex items-center mr-3">
                                <label className="relative inline-flex items-center cursor-pointer">
                                    <input type="checkbox" checked={openCards} onChange={() => setOpenCards(!openCards)} className="sr-only peer" />
                                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-800 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                    <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{t('abrirCards')}</span>
                                </label>
                            </div>
                        )}
                    </>
                )}
                <div className="inline-flex mb-4 rounded-[8px] shadow-sm" role="group">
                    {/* Botão de filtros */}
                    {!showForm && (
                        <button
                            type="button"
                            title={t('filtros')}
                            onClick={toggleDrawer('right', true)}
                            className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-200 rounded-l-[8px] hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white">
                            <FilterAltIcon />
                        </button>
                    )}

                    {/* botão de voltar */}
                    {showForm && (
                        <button
                            type="button"
                            title={t('voltar')}
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border border-gray-200  hover:bg-gray-100 hover:text-blue-700 focus:z-10  dark:bg-blue-700 text-blue-700 focus:ring-blue-700 focus:ring-2 rounded-l-[8px] dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-500 dark:focus:text-white`}
                            onClick={() => {
                                if (onChangeForm) {
                                    setOpenExit(true);
                                } else {
                                    voltar();
                                }
                            }}>
                            {<KeyboardBackspaceRoundedIcon />}
                        </button>
                    )}

                    {/* Botão para filtrar */}
                    {showForm && openTab == 7 && (
                        <button
                            type="button"
                            title={t('filtros')}
                            onClick={toggleDrawer('right', true)}
                            className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-200  hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white">
                            <FilterAltIcon />
                        </button>
                    )}
                    {/* Botão para criar proposta */}
                    {!showForm && (
                        <button
                            type="button"
                            title={t('criarProposta')}
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border border-gray-200   focus:z-10 dark:bg-gray-700 text-gray-500 rounded-r-[8px] dark:border-gray-600 dark:text-white  dark:focus:ring-blue-500 dark:focus:text-white ${
                                permissao.criar ? 'hover:bg-gray-100 hover:text-blue-700 dark:hover:text-white dark:hover:bg-blue-500' : 'cursor-not-allowed'
                            }`}
                            onClick={() => {
                                setShowForm(true);
                                setEditarProposta(true);
                                setOpenTab(1);
                            }}
                            disabled={!permissao.criar}>
                            {<NoteAddIcon />}
                        </button>
                    )}

                    {/* Botão para enviar email*/}
                    {showForm && propostaSelecionada && (
                        <button
                            title={t('enviarEmail')}
                            type="submit"
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border border-gray-200    focus:z-10   dark:bg-gray-700 dark:border-gray-600 dark:text-white  dark:focus:ring-blue-500 dark:focus:text-white ${
                                !propostaSelecionada.assinado || !permissao.modificar ? 'cursor-not-allowed' : ' dark:hover:bg-blue-500 hover:bg-gray-100 dark:hover:text-white hover:text-blue-700'
                            }`}
                            onClick={() => {
                                setEnviarEmailProposta(true);
                            }}
                            disabled={!propostaSelecionada.assinado || !permissao.modificar}>
                            {<EmailRoundedIcon />}
                        </button>
                    )}
                    {/* Botão para imprimir*/}
                    {showForm && propostaSelecionada && (
                        <button
                            title={t('imprimir')}
                            type="submit"
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border border-gray-200    focus:z-10   dark:bg-gray-700 dark:border-gray-600 dark:text-white  dark:focus:ring-blue-500 dark:focus:text-white ${
                                !propostaSelecionada.assinado /*editarProposta*/ ? 'cursor-not-allowed' : ' dark:hover:bg-blue-500 hover:bg-gray-100 dark:hover:text-white hover:text-blue-700'
                            }`}
                            onClick={() => {
                                setImprimirProposta(true);
                            }}
                            disabled={!propostaSelecionada.assinado /*editarProposta*/}>
                            {<LocalPrintshopRoundedIcon />}
                        </button>
                    )}

                    {/* Botão para nova revisão*/}
                    {showForm && propostaSelecionada && (
                        <button
                            title={t('novaRevisao')}
                            type="submit"
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border border-gray-200    focus:z-10   dark:bg-gray-700 dark:border-gray-600 dark:text-white   dark:focus:ring-blue-500 dark:focus:text-white ${
                                !propostaSelecionada.assinado || !permissao.modificar ? 'cursor-not-allowed' : ' dark:hover:bg-blue-500 hover:bg-gray-100 dark:hover:text-white hover:text-blue-700'
                            }`}
                            onClick={() => {
                                setGerarRevisaoProposta(true);
                            }}
                            disabled={!propostaSelecionada.assinado || !permissao.modificar}>
                            {<FileCopyRoundedIcon />}
                        </button>
                    )}

                    {/* Botão para popup de aprovação */}
                    {showForm && propostaSelecionada && (
                        <button
                            title={t('aprovacao')}
                            type="submit"
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border border-gray-200 focus:z-10 dark:bg-gray-700 dark:border-gray-600 dark:text-white   dark:focus:ring-blue-500 dark:focus:text-white ${
                                /*propostaSelecionada.aprovadoRep == 1 ||*/ !propostaSelecionada.assinado || acessos.filter(a => a.funcao == 'YSQHADMIN').length == 0 // userRepresentante.value !== propostaSelecionada.representante.value
                                    ? 'cursor-not-allowed'
                                    : ' dark:hover:bg-blue-500 hover:bg-gray-100 dark:hover:text-white hover:text-blue-700'
                            }`}
                            onClick={() => {
                                setOpenModalAprovacao(!openModalAssinatura);
                            }}
                            disabled={
                                /*propostaSelecionada.aprovadoRep == 1 ||*/ !propostaSelecionada.assinado || acessos.filter(a => a.funcao == 'YSQHADMIN').length == 0 // userRepresentante.value !== propostaSelecionada.representante.value
                            }>
                            {<DrawRoundedIcon />}
                        </button>
                    )}

                    {/* Botão para finalizar/Assinatura eletronica */}
                    {showForm && propostaSelecionada && (
                        <button
                            title={t('finalizar')}
                            type="submit"
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border border-gray-200 focus:z-10 dark:bg-gray-700 dark:border-gray-600 dark:text-white   dark:focus:ring-blue-500 dark:focus:text-white ${
                                propostaSelecionada.assinado || !permissao.modificar || !userRepresentante.assina
                                    ? 'cursor-not-allowed'
                                    : ' dark:hover:bg-blue-500 hover:bg-gray-100 dark:hover:text-white hover:text-blue-700'
                            }`}
                            onClick={() => {
                                setOpenModalAssinatura(!openModalAssinatura);
                            }}
                            disabled={propostaSelecionada.assinado || !permissao.modificar || !userRepresentante.assina}>
                            {<DownloadDoneRoundedIcon />}
                        </button>
                    )}

                    {/* Botão para encomenda*/}
                    {showForm && propostaSelecionada && (
                        <button
                            title={t('encomendar')}
                            type="submit"
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border border-gray-200    focus:z-10   dark:bg-gray-700 dark:border-gray-600 dark:text-white   dark:focus:ring-blue-500 dark:focus:text-white ${
                                /*propostaSelecionada.aprovadoRep !== 3 |*/ propostaSelecionada.aprovadoAdmin !== 3 || propostaSelecionada.encomendado || !permissao.modificar
                                    ? 'cursor-not-allowed'
                                    : ' dark:hover:bg-blue-500 hover:bg-gray-100 dark:hover:text-white hover:text-blue-700'
                            }`}
                            onClick={() => {
                                setOpenModalEncomenda(!openModalEncomenda);
                            }}
                            disabled={/*propostaSelecionada.aprovadoRep !== 3 ||*/ propostaSelecionada.aprovadoAdmin !== 3 || propostaSelecionada.encomendado || !permissao.modificar}>
                            {<LocalShippingRoundedIcon />}
                        </button>
                    )}

                    {/* Botão para ativar a edição de proposta */}
                    {showForm && !editarProposta && (
                        <button
                            title={t('editar')}
                            type="submit"
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border rounded-r-[8px] dark:bg-gray-700 border-gray-200    focus:z-10    dark:border-gray-600 dark:text-white   dark:focus:ring-blue-500 dark:focus:text-white ${
                                propostaSelecionada.assinado || !permissao.modificar ? 'cursor-not-allowed' : ' dark:hover:bg-blue-500 hover:bg-gray-100 dark:hover:text-white hover:text-blue-700'
                            }`}
                            onClick={() => {
                                setEditarProposta(true);
                            }}
                            disabled={propostaSelecionada.assinado || !permissao.modificar}>
                            {<CreateIcon />}
                        </button>
                    )}

                    {/* Botão para guardar */}
                    {showForm && editarProposta && (
                        <button
                            title={propostaSelecionada ? t('salvarMudancas') : t('salvar')}
                            type="submit"
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border rounded-r-[8px] border-gray-200  hover:bg-gray-100 hover:text-blue-700 focus:z-10   dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-500 dark:focus:text-white`}
                            onClick={() => {
                                //botaoEditarGuardar();
                                setGuardar(true);
                            }}>
                            {propostaSelecionada ? <SaveAsIcon /> : <SaveIcon />}
                        </button>
                    )}
                </div>
            </div>

            <Drawer anchor="right" open={state['right']} onClose={toggleDrawer('right', false)}>
                {list('right')}
            </Drawer>

            {openExit && (
                <ExitForm
                    cancelar={() => setOpenExit(false)}
                    back={() => {
                        setOpenExit(false);
                        voltar();
                    }}
                />
            )}
            {openModalAssinatura && (
                <AssinaturaModal
                    cancelar={() => setOpenModalAssinatura(false)}
                    assinar={() => {
                        setOpenModalAssinatura(false);
                        AssinarDoc();
                    }}
                />
            )}
            {openModalEncomenda && (
                <EncomendaModal
                    cancelar={() => setOpenModalEncomenda(false)}
                    encomendar={() => {
                        setOpenModalEncomenda(false);
                        Encomendar();
                    }}
                />
            )}

            {openModalAprovacao && (
                <AprovacaoModal
                    cancelar={() => setOpenModalAprovacao(false)}
                    aprovar={(aprovado, justificacao) => {
                        return AprovarOrcamento(aprovado, justificacao).then(res => {
                            setOpenModalAprovacao(false);
                        });
                    }}
                />
            )}
        </>
    );
}

export default DrawerFilter;
